import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const EmployeeTable = ({ employees, presentEmployees }) => {
  const fullName = (emp) => emp.name || emp.id;

  const sorted = [...employees].sort((a, b) =>
    presentEmployees.includes(b.id) - presentEmployees.includes(a.id)
  );

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#455a64' }}>
        Employee Status
      </Typography>
      <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#1565c0' }}>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Employee Code</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Name</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map(emp => {
              const present = presentEmployees.includes(emp.id);
              return (
                <TableRow key={emp.id} sx={{ backgroundColor: present ? '#e8f5e9' : '#ffebee' }}>
                  <TableCell>{emp.id}</TableCell>
                  <TableCell>{fullName(emp)}</TableCell>
                  <TableCell>
                    <span style={{ color: present ? '#2e7d32' : '#c62828', fontWeight: 'bold' }}>
                      {present ? '✅ Present' : '❌ Absent'}
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default EmployeeTable;